import { useFeature } from 'common/hooks/useFeature';
import FEATURES from 'src/core/constants/features';

export const useIsSchedulingUkTransfersFeatureEnabled = (): boolean =>
  useFeature(FEATURES.TMP_SCHEDULE_UK_TRANSFERS);
